import { Actions, Subjects } from 'constants/accessControlList';
import { useCanIAllOrMine, useRbac } from 'shared/features/rbac';
export var useCanICreateUnscheduledInteractions = function (memberId) {
    var canI = useRbac().canI;
    return useCanIAllOrMine(memberId, canI(Actions.Edit, Subjects.UnscheduledInteractionsAllMembers), canI(Actions.Edit, Subjects.UnscheduledInteractionsMyMembers));
};
